import styled from "styled-components/macro";

export const Container = styled.div`
  margin-top: 30px;
`;
